import type { Board } from 'chessboard/model/board/types';
import { KeyModifiers } from 'chessboard/model/dom/types';

/**
 * Get the color of an anlysis highlight from the key pressed.
 */
export function getHighlightColorFromKeyPressed(keyPressed: KeyModifiers, options: Board.Options) {
  switch (keyPressed) {
    case KeyModifiers.Alt:
      return options.analysisHighlightColors.alt;
    case KeyModifiers.Ctrl:
      return options.analysisHighlightColors.ctrl;
    case KeyModifiers.Shift:
      return options.analysisHighlightColors.shift;
    case KeyModifiers.None:
      return options.analysisHighlightColors.default;
    default:
      return undefined;
  }
}
